<template>
    <v-form ref="form">
        <v-row class="no-frame mt-3">
            <v-col class="no-frame pr-1">
                <v-text-field
                    label="Name"
                    v-model="user.firstname"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
            <v-col class="no-frame pl-1">
                <v-text-field
                    label="Name"
                    v-model="user.lastname"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :rules         = "[requiredRule]"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame">
                <f-enum-select
                    label        = "Niederlassung"
                    v-model      = "user.branch"
                    module       = "msd"
                    type         = "branches"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <v-text-field
                    label="Telefon"
                    v-model="user.phone"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :rules         = "[requiredRule]"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <v-text-field
                    label="Mobil"
                    v-model="user.mobile"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <v-text-field
                    label="FAX"
                    v-model="user.fax"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <v-text-field
                    label="Email"
                    v-model="user.email"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :rules         = "[requiredRule]"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <v-switch
                    label="Backoffice"
                    v-model="user.boUser"
                />
            </v-col>
            <v-col class="no-frame pl-2">
            </v-col>
        </v-row>
   </v-form>
</template>

<script>

import Core        from "@/modules/core/service/Core";
import User        from "@/modules/msd/user/service/User";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";


export default {
    name: "NavUserData",
    components: {
        FEnumSelect
    },

    data: () => ({
        dms: false,
        login: null,
        password: null,
    }),

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },

        user () {
            return this.preferences.user;
        },

        requiredRule () {
            return Core.rule.required;
        },
    },

    methods: {
        onSave () {
            if (!this.$refs.form.validate()) {
                return;
            }

            User.store(this.user).then(() => {
                Core.message.alert.save(this);
            })
        },
    }
}
</script>

<style scoped>

</style>